<script setup>
// Inline/reusable loading spinner
const props = defineProps({
  size: { type: String, default: 'md', validator: v => ['tiny','sm','md','lg'].includes(v) },
  label: { type: String, default: '' },
  layout: { type: String, default: 'row'}
});
</script>

<template>
  <span class="sw-spinner" :class="[`is-${size}`, `layout-${layout}`]" role="status" aria-live="polite">
    <span v-if="label" class="sr-only">{{ label }}</span>
  </span>
</template>

<style scoped>
.sw-spinner { display:inline-block; border:2px solid rgba(255,255,255,0.35); border-top-color: var(--sellwerk-color-secondary, #1790da); border-radius:50%; animation: swspin .65s linear infinite; }
/* Sizes */
.sw-spinner.is-tiny { width:12px; height:12px; border-width:2px; }
.sw-spinner.is-sm { width:14px; height:14px; border-width:2px; }
.sw-spinner.is-md { width:18px; height:18px; border-width:2.5px; }
.sw-spinner.is-lg { width:24px; height:24px; border-width:3px; }
/* Light theme */
.theme--light .sw-spinner { border-color: rgba(0,0,0,0.2); border-top-color: var(--sellwerk-color-main, #1677c5); }
@keyframes swspin { to { transform: rotate(360deg); } }
.sr-only { position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0 0 0 0); border:0; }
/* Layout */
.sw-spinner.layout-row {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5em;
}
.sw-spinner.layout-column {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2em;
}
.container:has(.sw-spinner.layout-column) {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5em;
}
.container:has(.sw-spinner.layout-row) {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5em;
}
</style>
